import { datadogLogs } from '@datadog/browser-logs';

export default {
  async install(Vue) {
    const config = jsConfig.datadogLogsConfig;

    if (! config) {
      return;
    }

    datadogLogs.init(config);
  }
}
